export default __webpack_public_path__ + "static/media/Group 12893.81312a88.svg";